import { createGlobalStyle } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const TIMELINE_INACTIVE = getToken('color-neutral-light')

export const ShipmentsPageStyle = createGlobalStyle`
  body {
    background: ${getToken('color-neutral-lightest')};
  }

  .ls-Shipment-map {
    position: relative;
    bottom: 28px;
    height: 425px;
    border: 1px solid ${getToken('color-neutral-light')};
    border-top: 0;
  }

  .ls-PageShipmentsTimeline {
    overflow: hidden;
  }

  .ls-PageShipmentsStatus {
    position: relative;
    margin-bottom: 4px;
    padding: 15px 0;
    background-color: ${getToken('color-neutral-white')};
    border: 1px solid ${getToken('color-neutral-light')};
    border-radius: 4px;

    &:before,
    &:after {
      position: absolute;
      top: 0;
      left: 25px;
      width: 3px;
      height: calc(100% + 2px);
      background-color: ${TIMELINE_INACTIVE};
      content: '';
    }

    &.is-first {
      &:before,
      &:after {
        top: 15px;
      }
    }

    &.is-last {
      &:before,
      &:after {
        top: -20px;
        height: 67%;
        max-height: 35px;
      }
    }

    &.is-previous {
      &:after,
      &:before {
        background-color: ${getToken('color-primary')};
      }
    }

    &.is-current:before {
      background-color: ${getToken('color-primary')};
    }
  }

  .ls-PageShipmentsStatus-stop {
    position: relative;
    margin-bottom: 19px;
    background-color: ${getToken('color-neutral-white')};
    border: 1px solid ${getToken('color-neutral-light')};
    border-radius: 4px;

    &.is-info {
      margin-bottom: 0;
      background-color: ${getToken('color-neutral-lighter')};
      border: 0;
    }
  }

  .ls-PageShipmentsStatus-stopInfo,
  .ls-PageShipmentsStatus-checkIn {
    position: relative;
    padding: 15px 0;
    border-bottom: 1px solid ${getToken('color-neutral-light')};

    &:before,
    &:after {
      position: absolute;
      top: 0;
      left: 25px;
      width: 3px;
      height: calc(100% + 2px);
      background-color: ${TIMELINE_INACTIVE};
      content: '';
    }

    &:before {
      top: -26px;
      z-index: 20;
      height: calc(66% + 10px);
    }

    &.is-previous {
      &:after,
      &:before {
        background-color: ${getToken('color-primary')};
      }
    }

    &.is-current:before {
      background-color: ${getToken('color-primary')};
    }
  }

  .ls-PageShipmentsStatus-checkIn {
    border-top: 1px solid ${getToken('color-neutral-light')};
  }

  .ls-PageShipments-uploadPOD-input {
    display: none;
  }

  .ls-PageShipments-uploadPOD {
    right: 13px;
    display: inline-block;
    min-width: 110px;
    margin: 0 10px 10px 0;
    padding: 10px;
    color: ${getToken('color-neutral-dark')};
    font-weight: 500;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    background: ${getToken('color-neutral-white')};
    border: 1px solid ${getToken('color-neutral-light')};
    border-radius: 50px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    &.is-upload {
      display: inline-block;
      color: ${getToken('color-neutral-white')};
      font-weight: 500;
      text-transform: uppercase;
      background: ${getToken('color-primary')};
      border: 0;
    }
  }
`
